import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function FAQ() {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(0);

    const faqs = [
        {
            q: t('faq.q1') || "How do I pay for my ride?",
            a: t('faq.a1') || "You can pay in cash directly to the driver or use a credit/debit card via the physical POS terminal in the vehicle."
        },
        {
            q: t('faq.q2') || "Can I cancel my booking?",
            a: t('faq.a2') || "Yes, you can cancel your booking free of charge up to 1 hour before the scheduled pickup time via messaging or calling in the number provided."
        },
        {
            q: t('faq.q3') || "Are there child seats available?",
            a: t('faq.a3') || "Yes, child seats are available upon request. Please specify this in the booking notes or contact us after booking."
        },
        {
            q: t('faq.q4') || "Do you offer airport transfers?",
            a: t('faq.a4') || "Absolutely! We specialize in airport transfers with flight monitoring to ensure we are there when you land."
        }
    ];

    return (
        <section id="faq" className="py-20 bg-gray-50">
            <div className="container mx-auto px-4 max-w-3xl">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('faq.title') || "FAQ"}</h2>
                    <div className="h-1 w-20 bg-blue-600 mx-auto rounded-full" />
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, idx) => (
                        <div
                            key={idx}
                            className="bg-white border border-gray-200 rounded-xl overflow-hidden transition-all"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                                className="w-full flex items-center justify-between p-6 text-left font-semibold hover:bg-gray-50 transition-colors"
                            >
                                {faq.q}
                                {openIndex === idx ? (
                                    <ChevronUp className="w-5 h-5 text-blue-600" />
                                ) : (
                                    <ChevronDown className="w-5 h-5 text-gray-400" />
                                )}
                            </button>
                            <div
                                className={`px-6 text-gray-600 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === idx ? "max-h-40 pb-6 opacity-100" : "max-h-0 opacity-0"
                                    }`}
                            >
                                {faq.a}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
